import * as React from "react";
import {InjectedIntlProps, injectIntl} from "react-intl";
import {connect} from "react-redux";
import {FIELD_NAME_MESSAGES, FieldFactory} from "../common/ui/search/FieldFactory";
import {DateField, SearchForm, SearchFormField, SelectField, TypeaheadTextField} from "../common/ui/search/SearchForm";
import {EntityType} from "../model";
import {actions} from "./actions";
import {ProductFilter as FilterObject, ProductType} from "./model";
import {selectors} from "./selectors";

interface ProductsFilterStateProperties {
  filter: FilterObject;
}

interface ProductsFilterDispatchProperties {
  filterChanged: (newFilter) => Promise<void>;
}

interface NotificationProps {
  notifyFilterChanged?: () => any;
}

type ProductFilterProps = ProductsFilterStateProperties & ProductsFilterDispatchProperties & NotificationProps;

export const ANY_TEXT_SEARCH_FIELD_NAME = "anyText";

class ProductsFilterComponent extends React.Component<InjectedIntlProps & ProductFilterProps, {}> {

  _fields: SearchFormField[];

  _typeaheadTextField: TypeaheadTextField;
  _typeField: SelectField;
  _dateStartField: DateField;
  _dateEndField: DateField;

  constructor(props) {
    super(props);
    this._typeaheadTextField = FieldFactory.createTypeaheadTextField(this.props.intl);
    this._typeField = FieldFactory.createTypeField([
      {label: this.props.intl.formatMessage(FIELD_NAME_MESSAGES.typeLabelAny), value: ""},
      {label: this.props.intl.formatMessage(FIELD_NAME_MESSAGES.typeLabelRaster), value: ProductType.RASTER},
      {label: this.props.intl.formatMessage(FIELD_NAME_MESSAGES.typeLabelVector), value: ProductType.VECTOR},
      {label: this.props.intl.formatMessage(FIELD_NAME_MESSAGES.typeLabelMesh), value: ProductType.MESH},
      {label: this.props.intl.formatMessage(FIELD_NAME_MESSAGES.typeLabelPointCloud), value: ProductType.POINT_CLOUD},
      {label: this.props.intl.formatMessage(FIELD_NAME_MESSAGES.typeLabelMixed), value: ProductType.MIXED},
      {label: this.props.intl.formatMessage(FIELD_NAME_MESSAGES.typeLabelEmpty), value: ProductType.EMPTY},
      {label: this.props.intl.formatMessage(FIELD_NAME_MESSAGES.typeLabelUnknown), value: ProductType.UNKNOWN},
    ]);
    this._dateStartField = FieldFactory.createStartDateField(this.props.intl);
    this._dateEndField = FieldFactory.createEndDateField(this.props.intl);
    this._fields = [
      this._typeaheadTextField,
      this._typeField,
      this._dateStartField,
      this._dateEndField,
    ];
  }

  handleSearch = (formValues) => {
    this.props.notifyFilterChanged && this.props.notifyFilterChanged();

    return this.props.filterChanged({
      anyText: formValues[this._typeaheadTextField.name],
      type: formValues[this._typeField.name],
      startDate: formValues[this._dateStartField.name],
      endDate: formValues[this._dateEndField.name],
    });
  }

  render() {
    const {filter} = this.props;
    return (
        <SearchForm fields={this._fields}
                    values={{
                      [this._typeaheadTextField.name]: filter.anyText || "",
                      [this._typeField.name]: filter.type || "",
                      [this._dateStartField.name]: filter.startDate || "",
                      [this._dateEndField.name]: filter.endDate || "",
                    }}
                    onSearch={this.handleSearch}
                    syncFieldsWithUrl={true}
                    entityType={EntityType.TYPE_PRODUCT}/>
    );
  }
}

const mapStateToProps = (state) => ({
  filter: selectors.getFilter(state),
});

const mapDispatchToProps = (dispatch) => {
  return {
    filterChanged: (newFilter) => {
      dispatch(actions.setFilter(newFilter));
      dispatch(actions.clearData());
      return Promise.resolve();
    },
  };
};

export const ProductsFilter = connect(mapStateToProps, mapDispatchToProps)(injectIntl(ProductsFilterComponent));
